
import { defineComponent } from "vue";

export default defineComponent({
  name: "kt-folder",
  props: {
    folderName: String,
    files: {
      type: [String, Number],
      default: 0
    },
    canManage: {
      type: Boolean,
      default: false
    }
  },
  emits: ["open", "rename", "delete"]
});
